export default "__VITE_ASSET__DnBKoc$j__"